<template >
  <div >
    <div >
      <h1
          class="clearfix online"
          v-if="workingServise" >
        {{ workingServise.title }} </h1 >
      <el-collapse-transition >
        <el-card
            class="box-card"
            v-if="!selectedTripId"
            key="cal" >
          <el-row >
            <el-col
                :sm="6"
                v-if="!forServise" >
              <el-row
                  v-for="excrs in excursionsList"
                  :key="excrs.id" >
                <h4
                    @click="routeGo({name:'bookServise',params:{tripServiseId:excrs.id}});loadAvailability()" >
                  {{ excrs.title }}!!{{ excrs.id }}</h4 >
              </el-row >
            </el-col >
            <el-col :sm="forServise?24:18" >
              <el-row >
                <el-divider content-position="left" >
                  How many are you joining our adventure?
                  <el-input-number
                      v-model="bookingPax"
                      controls-position="right"
                      @change="loadAvailability"
                      :min="1"
                      :max="100" ></el-input-number >
                </el-divider >
              </el-row >
              <el-divider content-position="left" >What date?</el-divider >
              <el-row >
                <v-calendar
                    @dayclick="selectDate"
                    is-expanded
                    v-loading="!loaded"
                    :available-dates="possibleDates"
                    @update:to-page="monthChanged"
                    xfrom-date="new Date(2019, 5, 1)"
                    :attributes="attributes" >
                  <!-- <div slot="day-content" slot-scope="scope">!{{scope.day.label}}{{scope.attributes}}</div> -->
                </v-calendar >
              </el-row >
              <!-- <p>{{possibleDates}}</p> -->
            </el-col >
          </el-row >
        </el-card >

        <el-card
            class="box-card"
            v-else
            key="book" >

          <online-booking-form
              :tripId="selectedTripId"
              :adultPax="bookingPax"
              @close="selectedTripId=null" ></online-booking-form >
        </el-card >
      </el-collapse-transition >
    </div >
  </div >
</template >

<script >
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";
import moment from "moment";

export default {
  mixins: [printHtml],
  data() {
    return {
      bookingPax: 1,
      workingServise: null,
      // selectedTripId: null,
      excursionsList: null,
      // browsedExcrsId: null,
      browsedMonth: null,
      loaded: false,
      possibleDates: [],
      notAvailableDates: null,
      attributes: [
        {
          dot: {
            color: "red",
            class: "my-dot-class",
          },
          dates: [
            new Date(2018, 0, 1), // Jan 1st
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 22), // Jan 22nd
          ],
        },
        {
          dot: "green",
          dates: [
            new Date(2018, 0, 4), // Jan 4th
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
        {
          dot: "purple",
          dates: [
            new Date(2018, 0, 12), // Jan 12th
            new Date(2018, 0, 26), // Jan 26th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
      ],
    };
  },
  methods: {
    selectDate(d) {//notAvailableDates
      const now = new Date(), hour = 60 * 60 * 1000
      if (now.getTime() > d.date.getTime())
        return;
      _log_("opa...diff.d.day,this.notAvailableDates,.", d, d.id, this.possibleDates)
      _log_("opa...diff..", now, d.date, (d.date.getTime() - now.getTime()) / hour);
      if ((d.date.getTime() - now.getTime()) / hour < 36) {
        this.$message.error("Unfortunately this trip must be booked 36 hours before (trip's) starting time");
        return
      }
      if (d.date.getDate() == now.getDate() && d.date.getMonth() == now.getMonth() && d.date.getFullYear() == now.getFullYear() && now.getHours() >= 20) {
        this.$message.error("Unfortunately this trip must be booked 36 hours before (trip's) starting time");
        return
      }
      const tripNoAv = this.findInArray(this.notAvailableDates, {id: d.id});
      if (tripNoAv) return
      const tripFound = this.findInArray(this.possibleDates, {id: d.id});
      if (tripFound) this.selectedTripId = tripFound.tripId;

    },
    getMonthRange(m, y) {
      var today = new Date();
      if (!m) m = today.getMonth() - 1;
      if (!y) m = today.getFullYear();
      return "1/" + m + "/" + y + "-1/" + (m + 1) + "/" + y;
    },
    async loadAvailability() {
      if (!this.forServise || !this.browsedMonth) return;
      this.loaded = false;
      let dataAv = await api.getModxList("scheduletrip", {
        serviseId: this.forServise,
        limit: 0,
        // forcedb: "travel2",
        daterange: this.browsedMonth,
        availability: true,
      });
      const vm = this;
      this.attributes = null;
      let notAvailableDates = [],
          highDemant = [],
          lowDemant = [];
      this.possibleDates = [null];
      _log_("AV check...", dataAv);
      if (dataAv && dataAv.length) {
        dataAv.forEach((trip) => {
          const tripDate = moment(trip.humandate, "DD/MM/YYYY")
              .toDate(), stmp = moment(trip.humandate, "DD/MM/YYYY")
              .format('YYYY-MM-DD')//new Date(trip.time * 1000);

          if (trip.paxData) trip.pax = trip.paxData.total_pax
          trip.pax = trip.pax ? trip.pax : 0;
          // _log_(
          //     "opa..check...",
          //     trip.id,
          //     stmp
          // );
          // vm.possibleDates.push(tripDate);

          if (trip.capacity - trip.pax - vm.bookingPax < 0) {
            notAvailableDates.push(tripDate);
            return
          }
          else if (
              (trip.capacity - trip.pax - vm.bookingPax) / trip.capacity >=
              0.5
          )
            lowDemant.push(tripDate);
          else highDemant.push(tripDate);
          vm.possibleDates.push({
            start: tripDate,
            end: tripDate,
            id: stmp,//,tripDate.getFullYear() + '-' + ((tripDate.getMonth() + 1) < 10 ? '0' + (tripDate.getMonth() + 1) : (tripDate.getMonth() + 1)) + '-' + (tripDate.getDay() < 10 ? '0' + tripDate.getDay() : tripDate.getDay()),
            day: tripDate.getDate(),
            tripId: trip.id,
          });
        });
        this.attributes = [
          {
            bar: {
              color: "red",
              class: "my-dot-class",
            },
            dates: notAvailableDates,
          },
          {
            bar: "green",
            dates: lowDemant,
          },
          {
            bar: "purple",
            dates: highDemant,
          },
        ];
      }
      else this.possibleDates = [null];
      this.loaded = true;

    },
    async loadAvailableExcursions() {
      var excrss = await api.getModxList("tripservice");

      this.workingServise = this.findInArray(excrss, {id: this.forServise})
      _log_("hel.this.forServise.", this.forServise, this.workingServise, this.workingServise);
      this.excursionsList = excrss;
    },
    async monthChanged(d) {
      const nd = this.getMonthRange(d.month, d.year);
      if (nd != this.browsedMonth) {
        this.browsedMonth = nd;
        await this.loadAvailability();
      }

      // _log_("hel..", d);
    },
    ...mapActions({
      fetchRooms: "hotelinfo/fetchRooms",
    }),

    goToBooking(data) {
      // _log_("bokk,,,", data);
      this.routeGo({
        name: "EditBooking",
        query: {bkid: data.row.idBooking},
      });
    },
  },
  async mounted() {
    await this.loadAvailableExcursions();
    this.loaded = true;
    // await this.loadAvailability()
    // _log_("the rs///", this.rooms);
  },
  computed: {
    selectedTripId: {
      get() {
        return parseInt(this.$route.query.selectedTrip);
      },
      set(v) {
        this.routeGo({query: {selectedTrip: v}});
      },
    },
    forServise() {
      return this.$route.params.tripServiseId &&
      this.$route.params.tripServiseId != "all"
          ? this.$route.params.tripServiseId
          : null;
    },
    xxattributes() {
      var av = [];
      return [
        {
          dot: {
            color: "red",
            class: "my-dot-class",
          },
          dates: [
            new Date(2018, 0, 1), // Jan 1st
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 22), // Jan 22nd
          ],
        },
        {
          dot: "green",
          dates: [
            new Date(2018, 0, 4), // Jan 4th
            new Date(2018, 0, 10), // Jan 10th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
        {
          dot: "purple",
          dates: [
            new Date(2018, 0, 12), // Jan 12th
            new Date(2018, 0, 26), // Jan 26th
            new Date(2018, 0, 15), // Jan 15th
          ],
        },
      ];
    },
    ...mapGetters({
      rooms: "hotelinfo/rooms",
    }),
    qBookings() {
      return {"bookingRange[]": bookingRange, searchall: searchall};
    },

    colDefinitions() {
      var rw = "380px";
      if (window.innerWidth < 500) rw = "150px";
      if (window.innerWidth < 700) rw = "240px";
      if (window.innerWidth < 1000) rw = "300px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },
        {prop: "refNum", width: "", label: "Αρ.Κρατησης"},
        {prop: "bookingDateF", width: "", label: "Ημερ.Κράτησης"},

        {prop: "firstName", width: "", label: "Ονομα"},

        {
          prop: "roomsF",
          width: rw,
          label: "Κράτηση",
          displayClass: "el-tag el-tag--info",
          component: {
            is: "v-rooms",
          },
        },
        // {
        //   prop: "asset_id",
        //   width: "180px",
        //   label: "Vehicle",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.vehicles,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // {
        //   prop: "driver_contact_id",
        //   width: "180px",
        //   label: "Driver",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.calcDriverList,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // {
        //   prop: "escort_contact_id",
        //   width: "180px",
        //   label: "Agent",
        //   editable: true,
        //   component: {
        //     is: "s-select",
        //     optionsRepo: this.escortList,
        //     labelProp: "name",
        //     valueProp: "id",
        //     filterable: true,
        //     clearable: true
        //   }
        // },
        // { prop: "destination", width: "180px", label: "Destination" },
        // { prop: "coname", width: "180px", label: "coname" }
      ];
    },
  },
};
</script >

<style >

h1.online {
  color: wheat;
  text-shadow: 0px 0px 1px orange;
}

@media screen and (max-width: 768px) {
  h1.online {
    font-size: 28px;
  }
}

.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}

span.vc-bg-green-600 {
  height: 30px !important;
  opacity: 20%;
}
</style >
